$(document).ready(function() {
  $('.styling-page-blog-posts ol').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});

document.querySelectorAll(".styling-contact-form p").forEach(p => {
    if (p.innerText.includes("Powered by Globo")) {
        p.style.display = "none";
    }
});

